import { cardBinLength } from '../../constants';
import { getCardInfoByBin } from '../../requests';
import { ExcludeCountryRule, ServerCard } from '../../types';

type Params = {
  cards: ServerCard[];
  excludeCardCountryCodes: ExcludeCountryRule[];
};

export const filterCardsByCountryCode = async ({
  cards,
  excludeCardCountryCodes,
}: Params): Promise<ServerCard[]> => {
  if (!excludeCardCountryCodes.length) {
    return cards;
  }

  const filteredByCountryCode: ServerCard[] = [];
  const excludeCodes = excludeCardCountryCodes.map(({ code }) => code.toUpperCase());

  const itemsWithoutVirtualCard = cards.filter((card) => !card.isOTTCard);
  const virtualCard = cards.find((card) => card.isOTTCard);

  if (virtualCard) {
    filteredByCountryCode.push(virtualCard);
  }

  const requests = itemsWithoutVirtualCard.map(({ cardMask }) =>
    getCardInfoByBin({ bin: cardMask.slice(0, cardBinLength) })
  );

  await Promise.allSettled(requests).then((responses) =>
    responses.forEach((response, index) => {
      if (response.status === 'fulfilled') {
        const { countryCode } = response.value;
        if (excludeCodes.length && !excludeCodes.includes(countryCode)) {
          filteredByCountryCode.push(itemsWithoutVirtualCard[index]);
        }
      }
    })
  );

  return filteredByCountryCode;
};
